import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import { ListItemIcon, styled } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useDispatch } from "react-redux";
import { setDomainName } from "./redux/auth";
import domainList, { Domain } from "./domainConfig";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const StyledList = styled(List)(({ theme }) => ({
  width: "100%",
  paddingBottom: 0,
  borderRadius: theme.shape.borderRadius * 1.6,
  boxShadow: '0px 1px 3px rgba(0,0,0,0.06), 0px 0px 0px 1px rgba(0,0,0,0.06)',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper,
}));

export default function Projects() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onDomainSelectHandler = (domain: Domain) => {
    dispatch(setDomainName({ domainName: domain }));
    navigate("/clients");
  };

  const wmsDomain = domainList.find((domain: Domain) =>
    domain.title.toLowerCase().includes("wms")
  );

  React.useEffect(() => {
    if (!!wmsDomain) {
      onDomainSelectHandler(wmsDomain);
    }

    //eslint-disable-next-line
  }, [wmsDomain]);

  return (
    <StyledList>
      <Header
        subheading="Please select the domain you wish to access!"
        heading="Select Domain"
      />
      <Divider component="li" />
      {domainList.map((domain: Domain, index) => {
        const keyName = process.env
          .REACT_APP_ENVIRONMENT as keyof typeof domain;
        const domainName = domain[keyName];

        return (
          <React.Fragment key={domain.title}>
            <ListItem
              onClick={() => onDomainSelectHandler(domain)}
              alignItems="center"
              sx={{
                cursor: "pointer",
                "&:hover": {
                  bgcolor: 'grey.50',
                },
              }}
            >
              <ListItemText
                primaryTypographyProps={{ fontWeight: 500, fontSize: 14 }}
                secondaryTypographyProps={{ fontWeight: 400, fontSize: 12, color: 'text.secondary' }}
                primary={domain.title}
                secondary={domainName}
              />
              <ListItemIcon sx={{ justifyContent: "center" }}>
                <KeyboardArrowRightIcon />
              </ListItemIcon>
            </ListItem>
            <Divider component="li" hidden={index + 1 === domainList.length} />
          </React.Fragment>
        );
      })}
    </StyledList>
  );
}
